import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Paragraph} = Typography;

const GWL = () => {
  return (
    <Layout style={{margin: '5.2vh 5.2vh 0 5.2vh', background: 'transparent'}}>
      <Paragraph className='Title2' style={{color: appColors['ColorNa']}}>Protocols</Paragraph>
      <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Characterization of the interactions between the aptamers and CRP</Paragraph>
      <Divider/>
    </Layout>
  );
};

export default GWL;
